exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-MFA-email-sent-email-sent-styles__mobileButton {\n    margin-top: 6.4rem;\n    width: 100%;\n    height: 4.8rem;\n}\n\n.src-MFA-email-sent-email-sent-styles__mobileActions {\n    padding-bottom: 1.6rem;\n}\n\n.src-MFA-email-sent-email-sent-styles__mobileActions .src-MFA-email-sent-email-sent-styles__mobileButton {\n    height: 4.8rem;\n    width: 100%;\n}\n", ""]);

// Exports
exports.locals = {
	"mobileButton": "src-MFA-email-sent-email-sent-styles__mobileButton",
	"mobileActions": "src-MFA-email-sent-email-sent-styles__mobileActions"
};